const NotFound = () => {
  return (
    <div>
      <h1 style={{color: "#333", marginLeft: "10px"}}>Page not found.</h1>
    </div>
  )
}
export default NotFound;